/* eslint no-param-reassign: "error" */

export default [
  {
    id: 'mercredi',
    content: `
    Your colleague Louie appears to be in distress! He seems to see you as his savior…
    "I'm going to need your legendary skills, you always know what to do with tricky problems…"
    
    How do you react ?
    `,
    choices: ['flatterie', 'santa', 'teamfirst'],
  },
  {
    id: 'flatterie',
    optionText: `You look forward to finding out what he needs!
    It's always gratifying to have your colleagues come looking for your help.`,
    content: `
    When a member of your team is in difficulty, you come to their rescue!
    Do take the time, however, to think about your answer: is it really possible to fit it into your schedule ?
    Is there a possibility that you said yes for fear of upsetting them?
    That might be a sign of those infamous "drivers" again, particularly the "please others".
    Be on your guard for those :)
    
    Louie isn't sure how to complete the project quality review procedure, and he'd appreciate a detailed refresher,
    as he's scared he might do it wrong. How would you respond to his request ?
    `,
    choices: ['documentation', 'occasion', 'deleguer'],
  },
  {
    id: 'documentation',
    optionText: `You send him the relevant documentation and remind him that you both attended
    the same training course on it last month; he'll manage !`,
    content: `
    This rather abrupt answer disappoints Louie somewhat. On the face of it, you are in the right,
    since you are keeping in mind your priorities and organization.
    Keeping your eye on your objectives when faced with external demands is not easy,
    but it is necessary in order to give value to your time, both for you and for your colleagues.
    
    At least encouraging him would be a good idea. That should help him to have some confidence in himself.
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'occasion',
    optionText: `You like spending time talking to your colleagues; this seems like too good a chance to pass it up.`,
    content: `
    Beware ! You didn't even consider how much time it would take you… nor the priority level of his request.
    And in the end, are you even the right person to respond to his request ?
    Alternatives might be available :)
    
    Furthermore, deep down, you know that Louie is a real talker… Overtime seems to be calling your name!
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'deleguer',
    optionText: `You suggest that he schedule the two of you for an hour-long meeting on the subject at the end of the day.
    In return, you will delegate the quality review of your project to him,
    suggesting he benefit from the practice of dealing from a second project review.`,
    content: `
    That's the way to do it! You are giving some time to Louie and setting boundaries.
    Setting a timeslot in the schedule is the very essence of mastering your time management.
    The cherry on the cake is that the return on your time investment is 100%,
    as you have given him a task to do… which would have taken you an hour to do. Well done !
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'santa',
    optionText: `I didn't know I was Santa Claus… The beard and red tunic don't suit me !`,
    content: `
    You were probably thinking aloud that perhaps Louie would wake up and
    remember that he can find the procedure in a comprehensive orientation document.
    He's a bit disappointed at first, but you were clear, factual and considerate, so Louie understands and
    will not hold it against you. On the contrary, you have helped him find a little perspective on his working methods.
    Take care, however, not to simply reject all requests before even clarifying what is involved.
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'teamfirst',
    optionText: `Let’s see what we can do, maybe it will be good for the team !`,
    content: `
    Your first instinct is to involve the team manager, who happens to be passing at the time.
    Louie explains that he doesn't remember how to carry out the quality review of the project.
    He asks for a detailed refresher, as he is scared he might do it wrong.
    Your manager thanks you for having thought of sharing the problem,
    and asks you to decide how best to go about responding to this request. How do you react ?
    `,
    choices: ['revue', 'envoi', 'parole'],
  },
  {
    id: 'revue',
    optionText: `You suggest spending half an hour going over the points that are unclear,
    so that both of you have the same information.`,
    content: `
    Half an hour is a pretty good timeslot to cover the important points.
    Make sure all attendees are able to prepare for the meeting, otherwise you may be wasting your time,
    and Louie will be back again next month for sure !
    Remember, this will involve being organized: reserve the timeslot in the calendars of the attendees,
    clearly define the objectives of the meeting,
    make sure everyone comes prepared… and of course, make sure it doesn't go over 30 minutes !
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'envoi',
    optionText: `You offer to send Louie the documents that you rely on when carrying out your quality reviews.`,
    content: `
    Louie may still have questions and may be back to bother you again within a week…
    You're not out of the woods yet !
    [See what the end of the week holds](@vendredi)
    `,
  },
  {
    id: 'parole',
    optionText: `Let Louie do the talking, after all, he is the one asking for help !`,
    content: `
    You're not willing to get your hands dirty, even though Louie needs help.
    If you were proactive, you might be better able to help him:
    he may have no idea how to deal with the problem, and may just duck out of solving it.
    [See what the end of the week holds](@vendredi)
    `,
  },
]
